module.exports = __webpack_public_path__ + "img/dirndl-blouse-amsterdam-d-blue.157abfae.png";